import { createGateway } from './config/gateway'

export const clientesBack = createGateway('clientes')

export const checkMail = createGateway('checkMail')

export const companyApi = createGateway('company')

export const organizationApi = createGateway('organization')

export const adminUsuarioApi = createGateway('adminUsuario')

export const registroUsuarioApi = createGateway('registroUsuario')
